import { render, staticRenderFns } from "./sme-preimum.vue?vue&type=template&id=40f811fa&scoped=true&"
import script from "./sme-preimum.vue?vue&type=script&lang=js&"
export * from "./sme-preimum.vue?vue&type=script&lang=js&"
import style0 from "./sme-preimum.vue?vue&type=style&index=0&id=40f811fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f811fa",
  null
  
)

export default component.exports